import React from 'react';
import axios from 'axios';
import {useState} from 'react';
import {useEffect} from 'react';
import Berechnung from '../Berechnung/Berechnung';
import Fall1 from '../../src/img/Fall1.svg';
import Fall2 from '../../src/img/Fall2.svg';
import Fall3 from '../../src/img/Fall3.svg';
import Bezeichnung from '../JSX/Bezeichnung';
import BiegungInput from '../JSX/Input';

const GetProduct = (props) => {
    const [name, setname] = useState('');

    const [kraftChild, setKraft] = useState(100);
    const [LaengeChild, setLaenge] = useState(1000);

    const url_str = window.location.href;
    const url = new URL(url_str);
    const search_params = url.searchParams;
    let id = search_params.get('PIDB');
    let language = search_params.get('LANGUAGE');

    if (id === null || language === null) {
        id = '1000052959';
        language = 'DE';
    }

    let URLType =
        'https://www.minitec.de/_app/BiegeTool/examplearray.php?produkt=' +
        id +
        '&LANGUAGE=' +
        language;

    useEffect(() => {
        axios
            .get(URLType)

            .then((result) => {
                setname(result);
            })

            .catch((err) => {
                console.log(err);
            });
    }, []);

    const InputHandler = (isKraft, isLaenge) => {
        const Kraft = {isKraft, isLaenge, id: Math.random().toString()};

        setKraft(Kraft.isKraft);
        setLaenge(Kraft.isLaenge);
    };

    props.ongetLanguage(language);

    return (
        <>
            <Bezeichnung array={name} id={id} language={language} />
            <BiegungInput
                array={name}
                onInputData={InputHandler}
                language={language}
            />
            <Berechnung
                nameArray={name}
                Belastungsfall={'1'}
                FallIMG={Fall1}
                Kraft={kraftChild}
                Laenge={LaengeChild}
                language={language}
                id={id}
            />
            <Berechnung
                nameArray={name}
                Belastungsfall={'2'}
                FallIMG={Fall2}
                Kraft={kraftChild}
                Laenge={LaengeChild}
                language={language}
                id={id}
            />
            <Berechnung
                nameArray={name}
                Belastungsfall={'3'}
                FallIMG={Fall3}
                Kraft={kraftChild}
                Laenge={LaengeChild}
                language={language}
                id={id}
            />
        </>
    );
};

export default GetProduct;
